
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/landlords",
      function () {
        return require("private-next-pages/landlords.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/landlords"])
      });
    }
  